<template>
  <v-container fluid class="corrigendum-detail" v-if="corrigendum">
    <v-row class="flex-grow-0">
      <v-btn text
             x-small
             color="primary"
             exact
             :to="{name: 'sor-list'}">
        &lt;&lt; {{ $t('app_drawer.sor') }}
      </v-btn>
    </v-row>

    <v-row class="sor-info-wrapper">
      <v-col>
        <div class="sor-info">
          <h3>{{ corrigendum.name }}</h3>
          <div>{{ $t('sor.edition') }}: {{ corrigendum.edition.id }}</div>
          <div>{{ $t('sor.not_available_for_sale') }}</div>
        </div>
      </v-col>
    </v-row>

    <!--Excel-->
    <v-row :class="['corrigendum-detail-row', 'mt-8', 'rounded']">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t('corrigendum.excel') }}</span>
        <a href="corrigendum_input_template.xlsx"
           target="_blank">
          <v-btn color="primary"
                 small
                 class="ml-4"
                 v-if="!corrigendum.finalised_at">
            {{ $t('corrigendum.download_template') }}
          </v-btn>
        </a>
        <v-btn color="primary"
               small
               class="ml-4"
               v-if="!corrigendum.finalised_at"
               @click="importCorrigendum">
          {{ $t('corrigendum.import_title') }}
        </v-btn>
        <span class="corrigendum-finalised-div"
              v-if="corrigendum.finalised_at">
          {{ $t('sor.finalised') }}
          <v-icon color="#5BC23F"
                  small>mdi-check</v-icon>
        </span>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               small
               class="ml-4"
               v-if="corrigendum.excel && !corrigendum.finalised_at"
               @click="finaliseExcel">
          Finalise
        </v-btn>
        <!--        <v-btn color="primary"-->
        <!--               small-->
        <!--               class="ml-4"-->
        <!--               v-if="corrigendum.finalised_at"-->
        <!--               :disabled="corrigendum.action_input_finalised_at"-->
        <!--               @click="unfinaliseExcel">-->
        <!--          {{ $t('sor.un_finalise') }}-->
        <!--        </v-btn>-->
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table :items="excelItems"
                      :headers="excelHeaders"
                      hide-default-footer>
          <template #no-data>
            No Corrigendum Excel Uploaded
          </template>
          <template #item.excel.created_at="{value}">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at="{value}">
            {{ value ? $parseDate(value) : '' }}
          </template>
          <template v-slot:item.actions="{item}">
            <div class="d-flex">
              <v-btn text
                     color="primary"
                     @click="$downloadFile(item.excel.id)">
                {{ $t('download') }}
              </v-btn>
              <v-btn text
                     color="primary"
                     v-if="!item.finalised_at"
                     @click="previewExcel(item)">
                PDF
                <v-icon class="mr-2"
                        v-if="!item.finalised_pdf">mdi-file-alert
                </v-icon>
              </v-btn>
              <v-btn text
                     color="primary"
                     v-if="item.finalised_at"
                     @click="$downloadFile(item.finalised_pdf)">
                PDF
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!--Corrigendum ACTION Input-->
    <v-row class="corrigendum-disable-row mt-8 rounded"
           v-if="!corrigendum.finalised_at">
      <v-col>
        <span class="font-weight-bold mr-8">{{ $t('corrigendum.action_input') }}</span>
        {{ $t('corrigendum.action_input_not_available') }}
      </v-col>
    </v-row>
    <v-row :class="['corrigendum-detail-row', 'mt-8', 'rounded']"
           v-if="corrigendum.finalised_at">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t('corrigendum.action_input') }}</span>
        <v-btn color="primary"
               small
               class="ml-4"
               v-if="!corrigendum.action_input_finalised_at"
               @click="regenActionInput">
          REGENERATE
        </v-btn>
        <v-btn color="primary"
               small
               class="ml-4"
               :disabled="!corrigendum.action_input"
               @click="$downloadFile(corrigendum.action_input.id)">
          {{ $t('sor.download_action_input') }}
        </v-btn>
        <v-btn color="primary"
               small
               class="ml-4"
               :disabled="!corrigendum.action_input"
               v-if="!corrigendum.action_input_finalised_at"
               @click="importActionInput">
          {{ $t('sor.import_action_input') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               small
               class="ml-4"
               :disabled="!corrigendum.action_input"
               v-if="!corrigendum.action_input_finalised_at"
               @click="finaliseActionInput">
          {{ $t('sor.finalise') }}
        </v-btn>
        <!--        <v-btn color="primary"-->
        <!--               small-->
        <!--               class="ml-4"-->
        <!--               v-if="corrigendum.action_input_finalised_at"-->
        <!--               @click="unfinaliseActionInput">-->
        <!--          {{ $t('sor.un_finalise') }}-->
        <!--        </v-btn>-->
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table :items="actionItems"
                      :headers="actionHeaders"
                      hide-default-header
                      hide-default-footer>
          <template #no-data>
            {{ $t('sor.action_input_being_generated') }}
          </template>
          <template #item.created_at="{value}">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at>
            {{ corrigendum.action_input_finalised_at ? $parseDate(corrigendum.action_input_finalised_at) : '' }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!--Combined ACTION Input-->
    <v-row class="corrigendum-disable-row mt-8 rounded"
           v-if="!corrigendum.action_input_finalised_at">
      <v-col>
        <span class="font-weight-bold mr-8">{{ $t('corrigendum.finalised_action_input') }}</span>
        {{ $t('corrigendum.finalised_action_input_not_available') }}
      </v-col>
    </v-row>
    <v-row :class="['corrigendum-detail-row', 'mt-8', 'rounded']"
           v-if="corrigendum.action_input_finalised_at">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t('corrigendum.finalised_action_input') }}</span>
        <v-btn color="primary"
               small
               class="ml-4"
               :disabled="!corrigendum.finalised_action_input"
               @click="$downloadFile(corrigendum.finalised_action_input.id)">
          {{ $t('sor.download_action_input') }}
        </v-btn>
        <v-btn color="primary"
               small
               class="ml-4"
               :disabled="!corrigendum.reference_table"
               @click="$downloadFile(corrigendum.reference_table)">
          {{ $t('sor.download_reference_table') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table :items="combineActionItems"
                      :headers="actionHeaders"
                      hide-default-header
                      hide-default-footer>
          <template #no-data>
            {{ $t('sor.action_input_being_generated') }}
          </template>
          <template #item.created_at="{value}">
            {{ $parseDate(value) }}
          </template>
          <template #item.finalised_at>
            {{ corrigendum.action_input_finalised_at ? $parseDate(corrigendum.action_input_finalised_at) : '' }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import {computed} from "@vue/composition-api/dist/vue-composition-api";
import ImportActionInputDialog from "@/components/sor/ImportActionInputDialog";
import ImportCorrigendumDialog from "@/components/sor/ImportCorrigendumDialog";
import CorrigendumPreviewModal from "@/components/corrigendum/CorrigendumPreviewModal";

export default {
  name: 'Corrigendum',
  components: {},
  setup(props, {root}) {
    const corrigendum = ref(null);
    const getCorrigendum = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/sor/',
        params: {
          sor_id: root.$route.params.corrigendumId,
        },
      });

      if (response.body.success) {
        corrigendum.value = response.body.sor;
      }
    }

    const importCorrigendum = async function () {
      const result = await root.$dialog.showAndWait(ImportCorrigendumDialog, {
        corrigendumId: root.$route.params.corrigendumId,
        showClose: false,
        persistent: true,
        width: 640,
      })

      if (result === true) {
        refresh()
      }
    }

    const excelItems = computed(() => {
      if (corrigendum.value && corrigendum.value.excel) {
        return [corrigendum.value];
      }

      return [];
    })
    const excelHeaders = ref([
      {text: 'Last Update', value: 'excel.created_at', width: 150},
      {text: 'Filename', value: 'excel.filename'},
      {text: 'Finalised At', value: 'finalised_at', width: 150},
      {text: '', value: 'actions', sortable: false, width: 100},
    ]);
    const previewExcel = async function (item) {
      await root.$dialog.showAndWait(CorrigendumPreviewModal, {
        corrigendumId: item.id,
        corrigendum: item,
        width: '70vw',
        showClose: false,
        persistent: true,
        scrollable: true,
      })

      await getCorrigendum();
    }
    const finaliseExcel = async function () {
      if (await root.$dialog.confirm({text: root.$t('corrigendum.finalise_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/corrigendum/finalise/',
          params: {corrigendum_id: root.$route.params.corrigendumId},
        });

        if (response.body.success) {
          await getCorrigendum();
        }
      }
    }
    const unfinaliseExcel = async function () {
      if (await root.$dialog.confirm({text: root.$t('corrigendum.un_finalise_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/corrigendum/unfinalise/',
          params: {corrigendum_id: root.$route.params.corrigendumId},
        });

        if (response.body.success) {
          await getCorrigendum();
        }
      }
    }

    const actionItems = computed(() => {
      if (corrigendum.value && corrigendum.value.action_input) {
        return [corrigendum.value.action_input];
      }

      return [];
    });
    const combineActionItems = computed(() => {
      if (corrigendum.value && corrigendum.value.finalised_action_input) {
        return [corrigendum.value.finalised_action_input];
      }

      return [];
    });
    const actionHeaders = ref([
      {text: root.$t('action_input.created_at'), value: 'created_at', width: 150},
      {text: root.$t('action_input.filename'), value: 'filename'},
      {text: root.$t('action_input.finalised_at'), value: 'finalised_at', width: 150},
    ])
    const regenActionInput = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/corrigendum/regen_action_input/',
        params: {corrigendum_id: root.$route.params.corrigendumId},
      });

      if (response.body.success) {
        await getCorrigendum();
      }
    }
    const downloadActionInput = function () {

    };
    const importActionInput = async function () {
      await root.$dialog.showAndWait(ImportActionInputDialog, {
        corrigendumId: root.$route.params.corrigendumId,
        showClose: false,
        persistent: true,
      });
      await getCorrigendum();
    }
    const finaliseActionInput = async function () {
      if (await root.$dialog.confirm({text: root.$t('sor.finalise_action_input_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/corrigendum/finalise_action_input/',
          params: {corrigendum_id: root.$route.params.corrigendumId},
        });

        if (response.body.success) {
          await getCorrigendum();
        }
      }
    }
    const unfinaliseActionInput = async function () {
      if (await root.$dialog.confirm({text: root.$t('sor.unfinalise_action_input_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/corrigendum/unfinalise_action_input/',
          params: {corrigendum_id: root.$route.params.corrigendumId},
        });

        if (response.body.success) {
          await getCorrigendum();
        }
      }
    }

    const refreshTrigger = ref(false);
    const refresh = function () {
      getCorrigendum();
    };

    onMounted(() => {
      getCorrigendum();
    })

    return {
      corrigendum,

      importCorrigendum,

      excelItems,
      excelHeaders,
      previewExcel,
      finaliseExcel,
      unfinaliseExcel,

      actionItems,
      combineActionItems,
      actionHeaders,
      regenActionInput,
      downloadActionInput,
      importActionInput,
      finaliseActionInput,
      unfinaliseActionInput,

      refreshTrigger,
      refresh,
    }
  },
}
</script>

<style lang="less">
.corrigendum-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .sor-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .sor-info {
      flex: 1 1 0;
    }

    .sor-info-btns {
      flex: 0 0 auto;
      width: 200px;
    }
  }

  .corrigendum-disable-row {
    flex: 0 0 auto;
    background-color: rgba(238, 119, 122, 0.1);
  }

  .corrigendum-finalised-div {
    border: solid 1px #5BC23F;
    border-radius: 12px;
    color: #5BC23F;
    background-color: rgba(91, 194, 63, 0.2);
    padding: 2px 8px;
    margin-left: 8px;
  }

  .corrigendum-detail-row {
    flex: 0 0 auto;
    background-color: #FFFFFF;

    &.finalised {
      background-color: #FFFFFF88;
    }
  }
}
</style>
